import { useMemo } from 'react';

import { useSelfServiceAccount } from '@eneco/auth-be-self-service';
import { ShowPersonalInfoCardResponse } from '@eneco/dc-be/client';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';
import { DashboardLink } from './DashboardLink';
import ReadFormField from '../../../../components/ReadFormField';

export const ShowPersonalInfoCard = ({ card }: { card: ShowPersonalInfoCardResponse }) => {
  const { fields } = useContent<DashboardOverviewRendering>();
  const {
    selectedAccount: { role },
  } = useSelfServiceAccount();
  const roleValue = useMemo(() => {
    switch (role) {
      case 'reader':
        return fields.showPersonalInfoCard?.readerLabel.value || 'Reader [not in Sitecore]';
      case 'editor':
        return fields.showPersonalInfoCard?.editorLabel.value || 'Editor [not in Sitecore]';
      case 'owner':
        return fields.showPersonalInfoCard?.ownerLabel.value || 'Owner [not in Sitecore]';
      default:
        return '';
    }
  }, [role, fields]);

  return (
    <StyledDashboardBlock>
      <ReadFormField
        label={fields.showPersonalInfoCard?.customerNumberLabel.value || 'Customer Number [not in Sitecore]'}
        value={card.details.accountNumber}
      />
      <ReadFormField
        label={fields.showPersonalInfoCard?.customerNameLabel.value || 'Customer Name [not in Sitecore]'}
        value={card.details.firstName + ' ' + card.details.lastName}
      />
      <ReadFormField
        label={fields.showPersonalInfoCard?.roleLabel.value || 'Role [not in Sitecore]'}
        value={roleValue}
      />
      <DashboardLink
        emphasis="high"
        href={fields.showPersonalInfoCard?.link.value?.href || ''}
        target={fields.showPersonalInfoCard?.link.value?.target || ''}
        trackingComponentName="show_personal_info_link"
        trackingComponentType="dashboard_link">
        {fields.showPersonalInfoCard?.link.value?.text || 'Link [not in Sitecore]'}
      </DashboardLink>
    </StyledDashboardBlock>
  );
};
